export const eventData = {
  event_location: [{ term_id: 40, term_name: "London Bridge" }],
  event_feed: [
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "London Bridge Event",
      id: 1118,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "London Bridge",
    },
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "Soho Event",
      id: 1131,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "Soho",
    },
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "South Kensington Event",
      id: 1131,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "South Kensington",
    },
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "Battersea Event",
      id: 1131,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "Battersea",
    },
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "Richmond Event",
      id: 1131,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "Richmond",
    },
    {
      stock_status: "instock",
      stock_count: "10",
      coming_soon: false,
      title: "Borough Market Event",
      id: 1131,
      non_fuse_event: "",
      event_time: "From 12pm",
      permalink:
        "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
      short_description: "",
      price:
        '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
      event_date: "25/01/2024",
      sort_date: "20240125",
      event_cutoff_date: "25-01-2024",
      image:
        '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
      event_tags: [39, 40],
      event_location: "Borough Market",
    },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "London Bridge Event",
    //   id: 1118,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "London Bridge",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Soho Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Soho",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "South Kensington Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "South Kensington",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Battersea Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Battersea",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Richmond Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Richmond",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Borough Market Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/02/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Borough Market",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "London Bridge Event",
    //   id: 1118,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "London Bridge",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Soho Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Soho",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "South Kensington Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "South Kensington",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Battersea Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Battersea",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Richmond Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Richmond",
    // },
    // {
    //   stock_status: "instock",
    //   stock_count: "10",
    //   coming_soon: false,
    //   title: "Borough Market Event",
    //   id: 1131,
    //   non_fuse_event: "",
    //   event_time: "From 12pm",
    //   permalink:
    //     "https://brindisafusdev.wpengine.com/product/event-test-copy/?event_date=2024-01-25",
    //   short_description: "",
    //   price:
    //     '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">&pound;</span>50.00</bdi></span>',
    //   event_date: "25/03/2024",
    //   sort_date: "20240125",
    //   event_cutoff_date: "25-01-2024",
    //   image:
    //     '<img width="980" height="589" src="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg" class="attachment-large size-large wp-post-image" alt="" decoding="async" loading="lazy" srcset="https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-1024x615.jpg 1024w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-300x180.jpg 300w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-768x461.jpg 768w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2-600x360.jpg 600w, https://brindisafusdev.wpengine.com/wp-content/uploads/2023/12/Brindisa-Sept-22-176-2.jpg 1440w" sizes="(max-width: 980px) 100vw, 980px" />',
    //   event_tags: [39, 40],
    //   event_location: "Borough Market",
    // },
  ],
};

export default eventData;
